import { MONAMI_HOST } from '@/config/env';

/**
 * Resolve an ExternalError's site-relative `path` (emitted by the online app's
 * SuperForm::ErrorNavigationClassifier) to an absolute href into the online
 * Mon Ami app. Fix-elsewhere errors live on records the offline app can't edit,
 * so the banner links to the online app.
 *
 * Returns `null` when `path` isn't site-relative, so the banner renders the
 * link text as plain text rather than a surprising cross-origin link.
 */
export function resolveOnlineErrorHref(path: string): string | null {
  return path.startsWith('/') ? `${MONAMI_HOST}${path}` : null;
}
